import { CylinderGeometry, Group, Mesh, SphereGeometry, Vector3 } from 'three';
import { RescueTool } from './RescueTool';

export class RescuePole extends RescueTool {
  private extension = 0;
  private targetExtension = 0;
  private readonly shaft: Mesh;
  private readonly hook: Group;

  constructor() {
    super('rescuePole');
    this.shaft = new Mesh(new CylinderGeometry(0.11, 0.17, 7, 10), this.standardMaterial(0x49a66f));
    this.shaft.rotation.z = Math.PI / 2;
    this.shaft.castShadow = true;
    this.hook = new Group();
    const grip = new Mesh(new SphereGeometry(0.33, 10, 7), this.standardMaterial(0xffc83d));
    this.hook.add(grip);
    this.group.add(this.shaft, this.hook);
    this.group.visible = false;
  }

  extend(origin: Vector3, direction: Vector3, amount: number): void {
    this.group.visible = true;
    this.group.position.copy(origin);
    this.group.lookAt(direction);
    this.group.rotateY(Math.PI / 2);
    this.targetExtension = Math.max(0.2, Math.min(1, amount));
  }

  override update(delta: number): void {
    this.extension += (this.targetExtension - this.extension) * Math.min(1, delta * 5);
    this.shaft.scale.y = this.extension;
    this.shaft.position.x = -3.5 * this.extension;
    this.hook.position.x = -7 * this.extension;
  }
}
